import React, { Component } from "react";
import { connect } from "react-redux";
import { mostrarModulo } from "../../../redux/actions/actGlobal";
import { withStyles } from "@material-ui/core/styles";
import { Tabs, Tab, Box } from "@material-ui/core";

import AssessmentIcon from "@material-ui/icons/Assessment";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import PublicIcon from "@material-ui/icons/Public";

import Resumen from "./Resumen";
import Tendencias from "./Tendencias";
import Global from "./Global";
import { registrarAcceso } from "../services/alertasGenericasService";

const styles = () => ({
  container: {
    display: "flex",
    height: "auto",
    alignItems: "stretch",
  },

  sidebarWrapper: {
    minWidth: "220px",
    borderRight: "1px solid #eee",
    paddingTop: "22px",
    paddingBottom: "0px",
    paddingLeft: "10px",
    paddingRight: "10px",
    alignSelf: "stretch",
  },

  sidebar: {
    width: "100%",
  },

  contenido: {
    flex: 1,
    padding: "12px 20px 16px",
  },

  tab: {
    alignItems: "flex-start", 
    justifyContent: "flex-start",
    textTransform: "none",
    minHeight: "40px",
    borderRadius: "10px",
    marginBottom: "4px",
    padding: "5px 6px",
    color: "#555",

    "& .MuiTab-wrapper": {
      flexDirection: "row", 
      justifyContent: "flex-start",
      gap: "10px",
    },

    "&.Mui-selected": {
      backgroundColor: "#aa0e19",
      color: "#fff",
    },
  },
});

class AlertaAdministrar extends Component {
  state = {
    activeTab: 0,
  };

  componentDidMount() {
    this.props.mostrarModulo({
      ruta: "/alertas_genericas",
      nombre: "Alertas Tempranas Genéricas",
    });
    registrarAcceso();
  }

  handleChangeTab = (event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  renderContenido = () => {
    const { activeTab } = this.state;

    switch (activeTab) {
      case 0:
        return <Resumen />;
      case 1:
        return <Tendencias />;
      case 2:
        return <Global />;
      default:
        return null;
    }
  };

  render() {
    const { classes } = this.props;
    const { activeTab } = this.state;

    return (
      <div className={classes.container}>
        <Box className={classes.sidebarWrapper}>
          <Tabs
            orientation="vertical"
            value={activeTab}
            onChange={this.handleChangeTab}
            className={classes.sidebar}
            TabIndicatorProps={{ style: { display: "none" } }} 
          >
            <Tab
              icon={<AssessmentIcon />}
              label="Resumen"
              className={classes.tab}
            />
            <Tab
              icon={<TrendingUpIcon />}
              label="Tendencias"
              className={classes.tab}
            />
            <Tab
              icon={<PublicIcon />}
              label="Global"
              className={classes.tab}
            />
          </Tabs>
        </Box>

        <Box className={classes.contenido}>
          {this.renderContenido()}
        </Box>
      </div>
    );
  }
}

export default connect(null, { mostrarModulo })(withStyles(styles)(AlertaAdministrar));